module.exports = __webpack_public_path__ + "static/media/simpleFile.491c41b3.png";